import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { breakpointMobile } from './breakpoints';

interface OwnProps {}

interface FooterProps extends OwnProps, WithStyles<typeof styles> {}

const FooterBase: FunctionComponent<FooterProps> = ({ children, classes }) => (
  <Paper className={classes.root} square>
    <Divider absolute className={classes.divider} />

    <Grid container justify="space-between" className={classes.buttons}>
      {children}
    </Grid>
  </Paper>
);

const styles = (theme: Theme) =>
  createStyles({
    buttons: {
      width: 840,
      [breakpointMobile(theme)]: {
        width: 'inherit',
      },
    },
    divider: {
      bottom: 'auto',
      top: -1,
    },
    root: {
      position: 'fixed',
      bottom: 0,
      height: 'auto',
      width: '100%',
      boxSizing: 'border-box',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      display: 'flex',
      justifyContent: 'center',
    },
  });

const enhance = compose<FooterProps, OwnProps>(pure, withStyles(styles));

export const Footer = enhance(FooterBase);

Footer.displayName = 'Footer';
